export const personalityTraits = {
  'INTJ': {
    title: '建筑师',
    catchPhrase: "照计划来，别搞花样。",
    coreTraits: [
      '逻辑清晰',
      '目标明确',
      '战略感强'
    ],
    strengths: [
      '擅长制定长远计划',
      '对复杂问题有独到见解'
    ],
    weaknesses: [
      '对情绪敏感度低',
      '有时显得冷漠'
    ],
    description: 'INTJ 是天生的规划师，他们喜欢掌控全局，习惯将生活视作一个需要优化的系统。无论是工作还是生活，INTJ 都倾向于用最有效的方式达成目标。他们不喜欢被打乱计划，所以总是显得冷静又坚定。对他们来说，效率和逻辑永远优先于情绪。'
  },
  'INTP': {
    title: '逻辑学家',
    catchPhrase: "这事有意思，我研究一下。",
    coreTraits: [
      '好奇心强',
      '善于思考',
      '逻辑缜密'
    ],
    strengths: [
      '喜欢钻研',
      '擅长分析问题背后的本质'
    ],
    weaknesses: [
      '容易分心',
      '对执行力兴趣不大'
    ],
    description: 'INTP 是天生的知识猎人，任何新奇的想法都能让他们瞬间进入研究模式。他们常常沉迷于自己的思考世界，对实际生活中的"执行环节"却兴趣缺缺。INTP 的脑海中总有无数未完成的理论和假设，是朋友眼中的"冷门知识百科全书"。'
  },
  'ENTJ': {
    title: '指挥官',
    catchPhrase: "听我的，没错。",
    coreTraits: [
      '目标导向',
      '决策果断',
      '领导能力强'
    ],
    strengths: [
      '擅长管理团队',
      '高效推动进程'
    ],
    weaknesses: [
      '有时显得过于强势',
      '忽略他人感受'
    ],
    description: 'ENTJ 天生带着领导者的光环，他们在任何场合都能迅速分析局势并做出决策。他们的目标感很强，喜欢带领团队一起前进。但由于过于追求结果，ENTJ 有时会被朋友调侃为"过于霸道的 C 位选手"。'
  },
  'ENTP': {
    title: '辩论家',
    catchPhrase: "我觉得事情没那么简单。",
    coreTraits: [
      '创意爆棚',
      '思维敏捷',
      '擅长辩论'
    ],
    strengths: [
      '思路清奇',
      '能从多个角度看待问题'
    ],
    weaknesses: [
      '有时难以专注',
      '容易"吵赢辩论，输掉关系"'
    ],
    description: 'ENTP 是社交场的"头脑风暴专家"，擅长拆解问题并提出新颖的解决方式。他们喜欢挑战规则，并通过辩论激发创意，但也容易因过于爱杠而让人感到压力。对 ENTP 来说，探索未知是人生最大的乐趣。'
  },
  // 外交型 (NF)
  'INFJ': {
    title: '提倡者',
    catchPhrase: "你这事，我懂。",
    coreTraits: [
      '洞察力强',
      '理想主义',
      '感情深刻'
    ],
    strengths: [
      '理解他人情绪',
      '愿意为了理想默默努力'
    ],
    weaknesses: [
      '容易对自己要求过高',
      '内心戏丰富'
    ],
    description: 'INFJ 是人群中的"灵魂治疗师"，总能看穿别人的情绪并给予真诚的支持。他们内心充满理想，但往往选择低调行动，独自承担许多责任。对于 INFJ 来说，帮助他人成长是一种自我满足。'
  },
  'INFP': {
    title: '调停者',
    catchPhrase: "让我先 emo 一下。",
    coreTraits: [
      '温柔',
      '感性',
      '注重内心价值观'
    ],
    strengths: [
      '情感细腻',
      '追求和谐美好的世界'
    ],
    weaknesses: [
      '情绪化',
      '容易陷入自我怀疑'
    ],
    description: 'INFP 是温柔的梦想家，他们希望世界变得更美好，同时对情感变化格外敏感。他们常常为了追求心中的理想而做出牺牲，但也会因为现实的不完美而感到失落。INFP 是朋友圈里的"情绪缓冲带"，但他们也需要时间自我疗愈。'
  },
  'ENFJ': {
    title: '主人公',
    catchPhrase: "大家一起加油！",
    coreTraits: [
      '外向',
      '富有感染力',
      '善于激励他人'
    ],
    strengths: [
      '擅长组织和调动气氛',
      '让团队充满活力'
    ],
    weaknesses: [
      '过于关注别人',
      '容易忽视自己'
    ],
    description: 'ENFJ 是天生的团队凝聚者，他们用真诚和热情感染每一个人。他们喜欢激励别人实现目标，自己也往往是社交圈中的中心人物。不过，由于过于在意他人的感受，他们偶尔会忽略自己的需求。'
  },
  'ENFP': {
    title: '活动家',
    catchPhrase: "冲就完事了！",
    coreTraits: [
      '热情',
      '好奇心强',
      '富有创意'
    ],
    strengths: [
      '想法丰富',
      '充满正能量和行动力'
    ],
    weaknesses: [
      '容易三分钟热度',
      '对细节缺乏耐心'
    ],
    description: 'ENFP 是朋友圈里的"点子王"，总能用自己的热情带动团队。他们对新事物充满好奇，总是有一堆大胆的计划，但执行力有时跟不上自己的脑洞。对 ENFP 来说，体验过程比结果更重要。'
  },
  // 守护型 (SJ)
  'ISTJ': {
    title: '物流师',
    catchPhrase: "按规矩来，别整花里胡哨的。",
    coreTraits: [
      '严谨',
      '注重细节',
      '踏实可靠'
    ],
    strengths: [
      '执行力强',
      '遵循规则，有条理性'
    ],
    weaknesses: [
      '对变化不太适应',
      '可能显得古板'
    ],
    description: 'ISTJ 是生活中的"制度维护者"，对秩序和规则有天然的热爱。他们总是能按时完成任务，是团队中可靠的中坚力量。ISTJ 的踏实风格常让朋友觉得有安全感，但也可能因过于注重细节显得保守。'
  },
  'ISFJ': {
    title: '守护者',
    catchPhrase: "这事我帮你搞定。",
    coreTraits: [
      '温暖',
      '踏实',
      '喜欢照顾他人'
    ],
    strengths: [
      '体贴入微',
      '总是能关注到别人忽略的小事'
    ],
    weaknesses: [
      '容易过度付出',
      '忽视自身需求'
    ],
    description: 'ISFJ 是身边那个永远"靠谱"的朋友，喜欢用行动表达关心。他们不善于表达自己，但却总能在关键时刻挺身而出，为别人排忧解难。ISFJ 需要学会给自己留些空间，而不是一味关注他人。'
  },
  'ESTJ': {
    title: '总经理',
    catchPhrase: "听我的，绝对靠谱。",
    coreTraits: [
      '实干派',
      '责任感强',
      '领导能力出众'
    ],
    strengths: [
      '目标明确',
      '擅长组织团队并达成结果'
    ],
    weaknesses: [
      '过于直接',
      '可能忽视团队的情绪'
    ],
    description: 'ESTJ 是团队中的"行动派"，喜欢把事情做到极致，并带动他人高效完成任务。他们习惯主导局面，对目标的执着追求让他们显得强势，偶尔需要放慢脚步倾听别人的声音。'
  },
  'ESFJ': {
    title: '执政官',
    catchPhrase: "大家都开心就好！",
    coreTraits: [
      '外向',
      '注重社交',
      '富有同理心'
    ],
    strengths: [
      '擅长调解人际关系',
      '让团队氛围和谐愉快'
    ],
    weaknesses: [
      '过于在意他人看法',
      '容易压力过大'
    ],
    description: 'ESFJ 是社交场合中的"气氛组组长"，总是主动关心身边的人，让大家感到被照顾。他们喜欢分享自己的生活，也希望别人能积极回应。ESFJ 对关系的在意是他们的优点，但也容易让他们背上不必要的心理负担。'
  },
  'ISTP': {
    title: '巧匠',
    catchPhrase: "别急，我试试看。",
    coreTraits: [
      '独立',
      '动手能力强',
      '喜欢探索新方法'
    ],
    strengths: [
      '擅长解决技术性问题',
      '思维灵活'
    ],
    weaknesses: [
      '情绪表达有限',
      '可能显得冷漠'
    ],
    description: 'ISTP 是生活中的"技术达人"，对机械、工具和各种实用技能充满兴趣。他们喜欢在行动中学习，并在问题中寻找乐趣。虽然 ISTP 常给人一种冷酷的感觉，但其实他们更喜欢用行动而不是语言表达自己。'
  },
  'ISFP': {
    title: '冒险家',
    catchPhrase: "随心一点，别那么累。",
    coreTraits: [
      '感性',
      '注重体验',
      '艺术感强'
    ],
    strengths: [
      '善于用创意表达情感',
      '追求生活的美好瞬间'
    ],
    weaknesses: [
      '容易回避冲突',
      '不善于规划未来'
    ],
    description: 'ISFP 是朋友圈里的"文艺青年"，对美和情感有着天然的敏感。他们喜欢随遇而安，用自己的方式发现生活中的小确幸。ISFP 的感性让他们充满魅力，但也可能因此缺乏长远规划。'
  },
  'ESTP': {
    title: '企业家',
    catchPhrase: "干就完了，别墨迹！",
    coreTraits: [
      '果断',
      '外向',
      '喜欢冒险'
    ],
    strengths: [
      '适应力强',
      '能够快速抓住机会'
    ],
    weaknesses: [
      '容易忽略细节',
      '决策有时过于草率'
    ],
    description: 'ESTP 是行动派中的行动派，他们对冒险和新鲜感充满热情。喜欢追求刺激的同时，也善于在人际交往中游刃有余。他们的果断让人佩服，但偶尔的鲁莽也会让他们吃点小亏。'
  },
  'ESFP': {
    title: '表演者',
    catchPhrase: "来，整点开心的！",
    coreTraits: [
      '外向',
      '热情',
      '享受当下'
    ],
    strengths: [
      '善于调节气氛',
      '用乐观感染他人'
    ],
    weaknesses: [
      '容易情绪化',
      '缺乏长远计划'
    ],
    description: 'ESFP 是生活的派对达人，他们喜欢与人分享欢乐，总能点燃社交场的气氛。他们活在当下的态度让人羡慕，但也需要平衡短期的快乐和长期的目标。'
  }
} as const;

// 定义类型
export type PersonalityType = keyof typeof personalityTraits;
export type PersonalityTrait = typeof personalityTraits[PersonalityType]; 